// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2D1RX","inputWrap":"CustomTip_inputWrap__3Gzvm"};